
export const isAuthenticatedSelector = ({
  authenticationReducer: { isAuthentificated },
}) => isAuthentificated;
